import { useState, useRef, useEffect, useCallback } from 'react';
import { MODE, SERVICE_URL, Styles, Table, SelectableTable } from '../../controls/Shared';

export default function BatchOpenDrawer(props) {

    const { userInfo } = props;
  
    const [batchData, setBatchData] = useState(null);
    const [batchTotalData, setBatchTotalData] = useState(null);
    const [responseMsg, setResponseMsg] = useState("");
    const [shiftNote, setShiftNote] = useState("");
    const [longNote, setLongNote] = useState("");
    const [confirmedBatches, setConfirmedBatches] = useState({});

    let batchTable = <div />;
    

    const { current: batchTableColumns } = useRef(
        [
            {
                header: "Payment ID",
                accessorKey: "paymentId"
            },
            {
                header: "Batch Date",
                accessorKey: "batchTimeStamp",
                cell: ({row}) => (
                    <div>{new Date(row.original.batchTimeStamp).toLocaleString('en-US')}</div>
                )
            },
            {
                header: "Category",
                accessorKey: "category"
            },
            {
                header: "Item",
                accessorKey: "item"
            },
            {
                header: "Amount",
                accessorKey: "batchAmount",
                cell: ({row}) => (
                  <div>{row.original.batchAmount.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                  })}</div>
                )
            },
            {
              header: "Total Payment",
              accessorKey: "batchTotalAmount",
              cell: ({row}) => (
                <div>{row.original.batchTotalAmount.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}</div>
              )
            },
            {
                header: "Payment Method",
                accessorKey: "batchPaymentMethod"
            },
            {
                header: "Registrant",
                accessorKey: "batchRegistrant"
            },
            {
                header: "Event",
                accessorKey: "batchEvent"
            },
            {
                header: "Year",
                accessorKey: "batchYear"
            }

        ]
      );

      const { current: batchTotalColumns } = useRef(
          [
            {
                header: "Method",
                accessorKey: "batchPaymentMethod"
            },
            {
                header: "Total",
                accessorKey: "batchAmount",
                cell: ({row}) => (
                  <div>{row.original.batchAmount.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                  })}</div>
                )
            }
          ]
      )

      const getBatched = useCallback(() => {
        setResponseMsg("Getting Batches...");
        const url = SERVICE_URL + "/getBatched";
    
        const body = JSON.stringify({
          "Unpaid" : true,
          "TestMode" : MODE === "TEST",
          "Requestor" : userInfo.userName
        });
        
        fetch(url, {
            method: 'POST',
            body: body,
            headers: {
              'Content-Type': 'application/json'
            }
          }).then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              if (response.status === 406) {
                setResponseMsg("No Batch Data found.");
              } else {
                setResponseMsg("There was a problem with the request for Batch data.");
              }
              
              return null;
            }
        })
        .then((responseJson) => {
            if (responseJson !== null) setResponseMsg("");
            setBatchData(responseJson);
        });  
      },[userInfo.userName]);      

    useEffect(() => {
        getBatched();
    },[getBatched]); 

    useEffect(() => {
      let totalData = [
          {batchPaymentMethod: "Amex", batchAmount: 0.00},
          {batchPaymentMethod: "Cash", batchAmount: 0.00},
          {batchPaymentMethod: "Check", batchAmount: 0.00},
          {batchPaymentMethod: "Credit Card - Front Desk", batchAmount: 0.00},
          {batchPaymentMethod: "Gift Certificate", batchAmount: 0.00},
          {batchPaymentMethod: "Square - Credit Cards", batchAmount: 0.00},
          {batchPaymentMethod: "Traveler's Check", batchAmount: 0.00},
          {batchPaymentMethod: "Visa/Mastercard/Discover", batchAmount: 0.00},
        ];
      if (Object.keys(confirmedBatches).length > 0) {
        let batchesForTotals = [];
        batchData.forEach((bd, index) => {
          if (confirmedBatches[index]) {
            batchesForTotals.push(bd);
          }
        });        
        const totals = batchesForTotals.reduce((acc, current) => {
          const key = current.batchPaymentMethod;
          // Initialize the group if it doesn't exist
          if (!acc[key]) {
            acc[key] = 0;
          }
          // Add current value to the group's total
          acc[key] += current.batchAmount;
          return acc;
        }, {}); 
        
        Object.keys(totals).forEach((key) => {
          const existingTotal = totalData.find(x => x.batchPaymentMethod === key);
          if (existingTotal !== undefined) {
            existingTotal.batchAmount = totals[key];
          } else {
            let data = {};
            data.batchPaymentMethod = key;
            data.batchAmount = totals[key];
            totalData.push(data);
          }          
        })        
      } 
      setBatchTotalData(totalData);     

    },[confirmedBatches, batchData])

    function batchDrawer() {
      setResponseMsg("Batching Drawer...");
      let batchesToSend = [];
      batchData.forEach((bd, index) => {
        if (confirmedBatches[index]) {
          batchesToSend.push(bd);
        }    
      })
      if (shiftNote === "") {
        alert("Please ensure Shift Note have values.")
      } else {
        const body = JSON.stringify({
          "Batches" : batchesToSend,
          "BatchDate" : new Date(),
          "ShiftNote" : shiftNote,
          "LongNote" : longNote,
          "TestMode" : MODE === "TEST",
          "Requestor" : userInfo.userName
        });
          const url = SERVICE_URL + "/batchDrawer";
          
              fetch(url, {
                  method: 'POST',
                  body: body,
                  headers: {
                      'Content-Type': 'application/json'
                  }
              }).then(response => {
                if (response.ok) {
                  return response.json();                  
                } else {
                  alert("Error when attempting to Batch the Drawer.")
                }
              }).then((responseJson) => {
                  getBatched();
                  //exportBatchReport(responseJson);
                  setShiftNote("");
                  setLongNote("");
                  setConfirmedBatches([]);
              });
      }
    } 
        
    let batchTotalTable = <div />;
    let userMsg = <div />;
    const hiddenFields = ["paymentId"];
    if (batchData !== null && responseMsg === "") {
        batchTable = <SelectableTable className="table" columns={batchTableColumns} data={batchData} hiddenFields={hiddenFields}
          setSelection={setConfirmedBatches} rowSelection={confirmedBatches}/>; 
        if (batchTotalData !== null) {
          batchTotalTable = <Table className="table" columns={batchTotalColumns} data={batchTotalData} hiddenFields={[]}/>;
        }
    } else {
        batchTable = <div />;
        userMsg = <div className="warning">{responseMsg}</div>;
    }

    return (
        <div>            
            <div className="checkin-content-tabbed">
              <label>
                Shift Note:
                <input type="text" onChange={e => setShiftNote(e.target.value)} value={shiftNote}/>
              </label>
              <label>
                Long Note:
                <input type="text" onChange={e => setLongNote(e.target.value)} value={longNote}/>
              </label>
              <button className='button' onClick={batchDrawer}>Batch Open Drawer</button>
              <div>
                <button className='button' onClick={getBatched}>Refresh</button> 
              </div>
                {userMsg}           
                <Styles>
                    {batchTable}
                </Styles>
                <Styles>
                  {batchTotalTable}
                </Styles>
            </div>
        </div>
        
    )
}